import axios from "axios"
import qs from "qs"
// import router from "@/router";
// import store from "@/store"  ;
import store from '@/store'

/**
 * 基于axios封装的请求方法
 * @param {Object} config - 请求参数
 * @param {Object} config.api - 接口相关配置
 * @param {string} config.api.url - 请求的地址
 * @param {string} [config.api.method='GET'] - 请求方法：GET, POST, DELETE, PUT...默认为GET
 * @param {number} [config.api.timeout=10000] - 超时时间
 * @param {string} [config.api.dataType='json'] - post请求的数据类型
 * @param {Object} [config.api.headers={}] - 额外配置的headers
 * @param {Object} [config.api.otherConfig={}] - 其他需要配置给axios的配置项
 * @param {Object} [config.params={}] - 要传递给本次请求的参数
 * @returns {Promise<{data: {}, success: boolean, message: string}>}
 */
export async function request({
  api: {
    url,
    method = "GET",
    timeout = 1000 * 60 * 15,
    dataType = "json",
    headers = {},
    otherConfig = {},
  },
  params = {},
  urlParams = [],
}) {
  if (urlParams && urlParams.length) {
    urlParams.forEach((key) => {
      url = url + "/" + key
    })
  }
  const parsMap = Object.assign({}, params)
  for (const key in parsMap) {
    // 排除必传的空值参数 格式 [key.require]
    let keySets = key.split(".")
    // 删除value值为空的key
    if (parsMap[key] === "" && keySets !== "require") {
      delete params[key]
    }
  }
  const config = {
    url,
    method,
    timeout,
    headers: {
      Authorization: store.state.token ? `Bearer ${store.state.token}` : "",
    },
  }

  if (config.method === "GET" || config.method === "get") {
    config.paramsSerializer = function (params) {
      return qs.stringify(params, { arrayFormat: "repeat" })
    }
    config.params = params
  } else {
    if (dataType === "application/x-www-form-urlencoded") {
      config.data = qs.stringify(params)
    } else {
      config.data = params
    }
  }

  if (JSON.stringify(headers) !== "{}") {
    config.headers = Object.assign(
      {},
      {
        ...config.headers,
        ...headers,
      }
    )
  }

  if (JSON.stringify(otherConfig) !== "{}") {
    Object.assign(config, { ...otherConfig })
  }

  const result = {
    success: false,
    data: {},
    message: "",
  }
  try {
    const r = await axios(config)
    if (r.data) {
      switch (r.data.code) {
        case "0":
          result.success = true
          result.data = r.data.data
          result.message = r.data.msg
          break
        case "0001":
        default:
          result.message = r.data.msg
      }
    } else {
      console.warn("has no r.data")
    }
  } catch (e) {
    if (e.response) {
      switch (e.response.status) {
        case 401: {
          // 刷新token失效！
          result.message = "登录信息过期，请重新登录"
          // 清除token缓存
          sessionStorage.removeItem("token")
          break
        }
        case 403: // Token过期刷新token
          result.message = e.response.statusText
          break
        case 404: // NotFound
          result.message = "访问地址不存在(404)"
          break
        case 500:
          result.message = e.response.statusText
          break
        case 501:
        case 502:
          result.message = "服务器维护中，请稍后再试"
          break
        default:
          result.message = e.response.statusText
      }
    } else if (
      Object.prototype.hasOwnProperty.call(e, "code") &&
      e.code === "ECONNABORTED"
    ) {
      result.message = "请求超时"
    } else if (e.message && e.message === "Network Error") {
      result.message = "无法连接到服务器"
    } else {
      if (e.message) {
        result.message = e.message
      } else {
        console.error(e)
      }
    }
  }
  return result
}
